import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Link2, X, GitMerge } from "lucide-react";

export function ManualLinkPicker({ qbEvent, gcalEvents, onMerge }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const filtered = gcalEvents.filter(e =>
    !search || e.name.toLowerCase().includes(search.toLowerCase())
  );

  if (!open) {
    return (
      <Button
        data-testid={`link-btn-${qbEvent.event_id}`}
        size="sm"
        variant="outline"
        className="text-xs border-blue-500/30 text-blue-400 hover:bg-blue-500/10"
        onClick={() => setOpen(true)}
      >
        <Link2 className="w-3 h-3 mr-1" /> Link to Calendar Event
      </Button>
    );
  }

  return (
    <div className="mt-2 border border-blue-500/20 rounded-sm bg-blue-500/5 p-3 space-y-2">
      <div className="flex items-center justify-between">
        <p className="text-xs font-semibold text-blue-400 uppercase tracking-wider">Select Calendar Event</p>
        <button onClick={() => { setOpen(false); setSearch(""); }} className="text-muted-foreground hover:text-foreground">
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
      <Input
        data-testid={`link-search-${qbEvent.event_id}`}
        placeholder="Search calendar events..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        className="h-7 text-xs bg-secondary/30 border-border"
      />
      <div className="max-h-48 overflow-y-auto space-y-1">
        {filtered.length === 0 ? (
          <p className="text-xs text-muted-foreground text-center py-3">No matching calendar events</p>
        ) : (
          filtered.map(ge => (
            <button
              key={ge.event_id}
              data-testid={`link-option-${ge.event_id}`}
              className="w-full flex items-center justify-between gap-2 py-1.5 px-2 rounded-sm text-left hover:bg-blue-500/10 transition-colors"
              onClick={async () => {
                try {
                  await onMerge(ge.event_id, qbEvent.event_id);
                  setOpen(false);
                } catch (err) { toast.error(err?.response?.data?.detail || "Merge failed"); }
              }}
            >
              <div className="min-w-0">
                <p className="text-sm font-medium truncate">{ge.name}</p>
                <p className="text-xs text-muted-foreground">{ge.start_date}{ge.venue ? ` · ${ge.venue}` : ''}</p>
              </div>
              <GitMerge className="w-3.5 h-3.5 text-blue-400 shrink-0" />
            </button>
          ))
        )}
      </div>
    </div>
  );
}
